import React from 'react';
import LocationTemplate from './LocationTemplate';

const RockyMountTemplate: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Rocky Mount"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27801", "27802", "27803", "27804"]}
      latitude={35.9382}
      longitude={-77.7905}
      population={54341}
      historicalFact="Known as the 'City of the Two States' due to its location on the border of Nash and Edgecombe counties."
      nearbyTowns={[
        "Wilson, NC",
        "Greenville, NC", 
        "Tarboro, NC",
        "Nashville, NC",
        "Spring Hope, NC",
        "Bailey, NC",
        "Elm City, NC",
        "Battleboro, NC"
      ]}
    />
  );
};

export default RockyMountTemplate;